var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [].concat(_vm.classList), style: _vm.styleList }, [
    _c(
      "div",
      { staticClass: "textarea__inner" },
      [
        _vm.variant !== "custom"
          ? _c("v-typo", {
              attrs: {
                classes: ["textarea__label"],
                element: "label",
                variant: "body-small"
              },
              domProps: { innerHTML: _vm._s(_vm.label) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value,
              expression: "value"
            }
          ],
          ref: "inputField",
          staticClass: "textarea__item",
          attrs: {
            disabled: _vm.disabled,
            placeholder: _vm.placeholder,
            required: _vm.validation
              ? _vm.validation.indexOf("required") > -1
              : false,
            tabindex: _vm.tabIndex
          },
          domProps: { value: _vm.value },
          on: {
            blur: _vm.handleFocusOut,
            focus: _vm.handleFocusIn,
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return (function() {
                return _vm.onEnter()
              })($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.value = $event.target.value
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "errorMessage", staticClass: "textarea__error" },
      [
        _c(
          "transition",
          {
            attrs: { name: "roll" },
            on: {
              enter: _vm.errorAnimationEnter,
              leave: _vm.errorAnimationLeave,
              "after-enter": _vm.errorAnimationAfterEnter
            }
          },
          [
            _vm.errorMessage[0]
              ? _c(
                  "div",
                  {
                    ref: "errorPerex",
                    staticClass: "textarea__error-container"
                  },
                  [
                    _c("v-typo", {
                      attrs: { variant: "body-paragraph" },
                      domProps: { innerHTML: _vm._s(_vm.errorMessage[0]) }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }